import McLayoutRow  from './McLayoutRow.vue'

McLayoutRow.install = function(Vue){
    Vue.component(McLayoutRow.name, McLayoutRow);
}

export default McLayoutRow;